import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { DipRegistrationLoggingNames } from '../core/enum/dip-registration-logging-names.enum';
import { LoggerEventEnum } from '../core/models/dip-registration-log-information.model';
import {DipRegistrationConfirmService} from '../core/services/dip-registration-confirm.service';
import {DipRegistrationContextService} from '../core/services/dip-registration-context.service';
import { DipRegistrationNavigationService } from '../core/services/dip-registration-navigation.service';
import { DiprsSpaLoggerService } from '../core/services/logger/diprs-spa-logger.service';

@Component({
    selector: 'dip-dip-registration-session-expired',
    templateUrl: './dip-registration-session-expired.component.html',
    styleUrls: ['./dip-registration-session-expired.component.scss'],
    standalone: false
})
export class DipRegistrationSessionExpiredComponent implements OnInit, OnDestroy {

  constructor(private router: Router,
              private dipRegistrationNavigationService: DipRegistrationNavigationService,
              private readonly dipRegistrationContextService: DipRegistrationContextService,
              private dipRegistrationConfirmService: DipRegistrationConfirmService,
              private spaLoggerService: DiprsSpaLoggerService) {
  }

  ngOnInit() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_ENTERED, DipRegistrationLoggingNames.SESSION_EXPIRED, { previousPageId: this.dipRegistrationNavigationService.getPreviousUrl() });
    this.dipRegistrationContextService.resetContextFlag();
    this.dipRegistrationConfirmService.stop();
  }

  async restart() {
    this.spaLoggerService.info(LoggerEventEnum.USER_ACTION, DipRegistrationLoggingNames.SESSION_EXPIRED, { id: 'START_AGAIN'});
    await this.router.navigate(['overview'], this.dipRegistrationContextService.buildParams());
  }

  ngOnDestroy() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_EXITED, DipRegistrationLoggingNames.SESSION_EXPIRED, null);
  }

}
